import React from "react"

import { SelectOption } from "shared/types/Select"

import {
  CopyProjectChildrenFormData,
  MoveProjectChildOverlayView
} from "./CopyProjectChildrenOverlayView"
import { useCopyProjectChildrenOverlayViewModel } from "./hooks/useCopyProjectChildrenOverlayViewModel"

export interface CopyProjectChildrenOverlayModel {
  headline?: string

  defaultFormData: CopyProjectChildrenFormData

  projectOptions: SelectOption<string>[]
  parentOptions: SelectOption<string>[]
  positionOptions: SelectOption<number>[]

  isLoadingProjects?: boolean
  isLoadingPositions?: boolean
  isSubmitting?: boolean

  onFormDataChange: (formData: CopyProjectChildrenFormData) => void
  onSubmit: (formData: CopyProjectChildrenFormData) => void
  onCancel: () => void
}

export interface CopyProjectChildrenOverlayProps
  extends CopyProjectChildrenOverlayModel {
  autoFocus?: boolean
}

export const CopyProjectChildrenOverlay = React.memo(
  (props: CopyProjectChildrenOverlayProps) => (
    <MoveProjectChildOverlayView
      {...useCopyProjectChildrenOverlayViewModel(props)}
    />
  )
)
